module.exports = __webpack_public_path__ + "img/liste-agences.591e2f21.svg";